import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import BookRide from '../components/BookRide';
import Footer from '../components/Footer';
import './Defence.css';

const pub = process.env.PUBLIC_URL;

const sectors = [
  { icon: 'Military.png', label: 'Military' },
  { icon: 'Law-Enforcement.png', label: 'Law Enforcement' },
  { icon: 'ground.png', label: 'Ground & Facility' },
  { icon: 'wild-life.png', label: 'Terrain & Wildlife' },
  { icon: 'fire.png', label: 'Fire & Rescue' },
];

const missionPhotos = [
  { img: 'image.webp', label: 'Fire & Rescue' },
  { img: 'Rectangle-11-768x441-1.webp', label: 'Construction & Mining' },
  { img: 'image-1.webp', label: 'Search & Rescue' },
];

const terrainCards = [
  {
    bg: 'orangebg.webp',
    title: 'Unmatched Power and Performance',
    text: 'Equipped with powerful 1000cc V-twin configurations, our vehicles are specifically designed for optimal performance in the most demanding defense environments. Engineered for rugged terrains and tactical missions, they provide unmatched reliability, maneuverability, and endurance, ensuring peak performance during critical operations.',
  },
  {
    bg: 'bluebg.webp',
    title: 'Innovative Cargo Solutions',
    text: 'Secure and accessible front and rear cargo spaces, optimized for mission-critical supplies, along with openable rear cargo planks that provide an expandable design.',
  },
  {
    bg: 'graybg.webp',
    title: 'Transportability on Demand',
    text: 'Designed for seamless mobility, it is both air-transportable for rapid deployment to remote locations and efficiently built for transport via standard military and civilian trucks.',
  },
  {
    bg: 'greenbg.webp',
    title: 'Enhanced Protective Systems',
    text: 'Built with a reinforced chassis, convertible roll cage, impact-resistant design, and a 5-point seat belt system for secure operation in extreme conditions.',
  },
];

const futureCards = [
  {
    img: '1.webp',
    title: 'Cost-Efficient Fleet Management',
    text: "Designed for efficiency, the vehicle's streamlined build and superior materials minimize maintenance needs, while reliable spare parts availability ensures quick, cost-effective repairs and reduced downtime.",
  },
  {
    img: '2.webp',
    title: 'Customisable for Tactical Excellence',
    text: 'Adapt our ATVs and UTVs for any mission with convertible roll cages, advanced safety, modular cargo, real-time navigation, and precision handling for optimal performance in any terrain.',
  },
  {
    img: '3.webp',
    title: 'Enhanced Durability and Reliability',
    text: 'Built to withstand the toughest environments, our vehicles feature heavy-duty construction, reinforced suspension, and weather-resistant systems to ensure consistent performance in extreme conditions, from deserts to mountainous regions.',
  },
  {
    img: '4.webp',
    title: 'Rapid Deployment Capabilities',
    text: 'Designed for quick mobilization, our ATVs and UTVs are lightweight, transportable, and easy to deploy in time-sensitive missions, allowing defense forces to act swiftly and efficiently in any situation.',
  },
  {
    img: '5.webp',
    title: 'Advanced Communication Integration',
    text: 'Our vehicles can be equipped with cutting-edge communication systems, ensuring seamless coordination during operations, real-time updates, and instant connectivity to command centers, even in the most remote locations.',
  },
  {
    img: '6.webp',
    title: 'Unmatched Terrain Navigation',
    text: "Our ATVs and UTVs are designed to tackle the most challenging terrains, offering superior traction, stability, and maneuverability. Whether it's rocky landscapes, dense forests, or desert sands, they ensure seamless operation in any environment.",
  },
];

function Defence() {
  return (
    <div>
      <Header />

      {/* ── Hero ── */}
      <section
        className="def-hero"
        style={{ backgroundImage: `url(${pub}/defence/defence-bg.webp)` }}
      >
        <div className="def-hero__overlay" />
        <div className="def-hero__content">
          <h1 className="def-hero__heading">
            Built for the Toughest Challenges,<br />
            Empowering Defence Missions
          </h1>
          <p className="def-hero__text">
            Our ATVs and UTVs are engineered to excel in demanding environments. From rugged
            terrains to high-stakes operations, our vehicles define durability, reliability,
            and performance — empowering defence and government forces to accomplish critical
            missions with ease.
          </p>
          <span className="def-hero__scroll">Scroll down ↓</span>
        </div>
      </section>

      {/* ── Partner statement ── */}
      <section className="def-statement">
        <h2 className="def-statement__text">
          Strengthen your forces by partnering with us. Let your forces conquer
          critical missions in the most challenging environments.
        </h2>
      </section>

      {/* ── Defence / Government applications ── */}
      <section className="def-apps">
        <Link
          className="def-apps__card"
          to="/contact"
          style={{ backgroundImage: `url(${pub}/defence/def.webp)` }}
        >
          <div className="def-apps__card-overlay" />
          <div className="def-apps__card-content">
            <h3 className="def-apps__card-title">Defence Applications</h3>
            <p className="def-apps__card-text">
              Engineered for modern defence operations, providing mission-ready mobility,
              offering air-transportable designs, exceptional off-road performance, and proven
              reliability. Engineered with customizable configurations, they excel in border
              patrols, reconnaissance, combat support, and rapid response in critical situations.
            </p>
          </div>
        </Link>
        <Link
          className="def-apps__card"
          to="/contact"
          style={{ backgroundImage: `url(${pub}/defence/gov.webp)` }}
        >
          <div className="def-apps__card-overlay" />
          <div className="def-apps__card-content">
            <h3 className="def-apps__card-title">Government Applications</h3>
            <p className="def-apps__card-text">
              Designed to excel in diverse government operations, these vehicles support
              critical tasks such as disaster relief, wildlife management, fire rescue, and
              search-and-rescue missions. With advanced off-road capabilities, enhanced cargo
              systems, and mission-specific customization, they deliver unmatched performance
              in demanding scenarios.
            </p>
          </div>
        </Link>
      </section>

      {/* ── Sectors icon strip ── */}
      <section className="def-sectors">
        <h2 className="def-sectors__heading">
          Off-road and tactical vehicles ready for any job
        </h2>
        <p className="def-sectors__sub">
          Our vehicles are built to tackle the toughest terrains and missions, ready to
          support defence, border patrol, and emergency operations.
        </p>
        <div className="def-sectors__grid">
          {sectors.map((s) => (
            <div className="def-sectors__item" key={s.label}>
              <img src={`${pub}/defence/${s.icon}`} alt={s.label} className="def-sectors__icon" />
              <span className="def-sectors__label">{s.label}</span>
            </div>
          ))}
        </div>

        <div className="def-sectors__photos">
          {missionPhotos.map((p) => (
            <div
              className="def-sectors__photo"
              key={p.label}
              style={{ backgroundImage: `url(${pub}/defence/${p.img})` }}
            >
              <span className="def-sectors__photo-label">{p.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Built for Any Terrain ── */}
      <section className="def-terrain">
        <h2 className="def-terrain__heading">
          Built for Any Terrain, Ready for Every Mission
        </h2>
        <p className="def-terrain__sub">
          Our line-up of deployable ATVs &amp; UTVs offers the best, for the best.
        </p>
        <div className="def-terrain__grid">
          {terrainCards.map((c) => (
            <div
              className="def-terrain__card"
              key={c.title}
              style={{ backgroundImage: `url(${pub}/defence/${c.bg})` }}
            >
              <div className="def-terrain__card-overlay" />
              <div className="def-terrain__card-content">
                <h3 className="def-terrain__card-title">{c.title}</h3>
                <p className="def-terrain__card-text">{c.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Driving the Future ── */}
      <section className="def-future">
        <h2 className="def-future__heading">
          Driving the Future of Critical Off-road Missions
        </h2>
        <p className="def-future__sub">
          Explore how we are revolutionising operations with next-level innovation.
        </p>
        <div className="def-future__grid">
          {futureCards.map((c) => (
            <div
              className="def-future__card"
              key={c.title}
              style={{ backgroundImage: `url(${pub}/defence/${c.img})` }}
            >
              <div className="def-future__card-overlay" />
              <div className="def-future__card-content">
                <h3 className="def-future__card-title">{c.title}</h3>
                <p className="def-future__card-text">{c.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <BookRide />
      <Footer />
    </div>
  );
}

export default Defence;
